import {
    Box,
    Checkbox,
    Grid,
    Hidden,
    IconButton,
    Theme,
    Typography,
    useMediaQuery,
    useTheme
} from "@mui/material";
import {
    BlackDownArrowIcon,
    BlueEditIcon,
    DeleteIcons,
    FundTransferArrow
} from "../../assets/SvgIcons";
import {
    CartItemInfoProps,
} from "./types";
import SchemeInfo from "./SchemeInfo";

export default function CartItemInfo({
    amcId,
    id,
    fundType,
    fromSchemeImg,
    fromSchemeName,
    fromSchemeCategory,
    fromSchemeSubCategory,
    fromSchemeRisk,
    fromSchemeRiskColor,
    toSchemeImg,
    toSchemeName,
    toSchemeCategory,
    toSchemeSubCategory,
    toSchemeRisk,
    toSchemeRiskColor,
    checked,
    isDeleteEnabled = true,
    isEditEnabled = true,
    cartItemDetails,
    onCheckboxClick,
    onDeleteClick,
    onEditClick = () => { return; },
    ...rest
}: CartItemInfoProps): JSX.Element {
    const cartItemInfo = {
        amcId,
        id,
        fundType,
        fromSchemeImg,
        fromSchemeName,
        fromSchemeCategory,
        fromSchemeSubCategory,
        fromSchemeRisk,
        fromSchemeRiskColor,
        toSchemeImg,
        toSchemeName,
        toSchemeCategory,
        toSchemeSubCategory,
        toSchemeRisk,
        toSchemeRiskColor,
        cartItemDetails,
        ...rest
    }

    return (
        <>
            <Hidden lgUp>
                <Box>
                    <Grid
                        container
                        flexWrap="nowrap"
                        sx={{ columnGap: "15px" }}
                    >
                        <Grid
                            item
                            container
                            xs={10}
                            flexWrap="nowrap"
                            sx={{ columnGap: "15px" }}
                        >
                            <Grid item>
                                <Checkbox
                                    sx={(theme: Theme) => ({
                                        padding: "0px",
                                        '&.Mui-focusVisible, &:focus-within': {
                                            outline: `2px solid ${theme.palette.primary.main}`,
                                            outlineOffset: '2px',
                                            borderRadius: '4px',
                                        },
                                    })}
                                    checked={checked}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                        onCheckboxClick(fundType, id, event.target.checked)
                                    }
                                    inputProps={{
                                        'aria-label': `Select cart item ${fromSchemeName ?? ''}`.trim(),
                                    }}
                                />
                            </Grid>
                            <Grid
                                item
                                container
                                flexDirection="column"
                                sx={{ rowGap: "10px" }}
                            >
                                <SchemeInfo
                                    schemeImg={fromSchemeImg}
                                    schemeName={fromSchemeName}
                                    schemeCategory={fromSchemeCategory}
                                    schemeSubCategory={fromSchemeSubCategory}
                                    schemeRisk={fromSchemeRisk}
                                    schemeRiskColor={fromSchemeRiskColor}
                                    amcId={amcId}
                                />
                                {toSchemeName && (
                                    <>
                                        <BlackDownArrowIcon />
                                        <SchemeInfo
                                            schemeImg={toSchemeImg}
                                            schemeName={toSchemeName}
                                            schemeCategory={toSchemeCategory}
                                            schemeSubCategory={toSchemeSubCategory}
                                            schemeRisk={toSchemeRisk}
                                            schemeRiskColor={toSchemeRiskColor}
                                            amcId={amcId}
                                        />
                                    </>
                                )}
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            container
                            xs={2}
                            justifyContent="flex-end"
                            alignItems="flex-start"
                            sx={{ columnGap: "8px" }}
                        >
                            {isEditEnabled && (
                                <IconButton
                                    sx={{ padding: "0px 5px 5px" }}
                                    onClick={() => onEditClick(cartItemInfo)}
                                    aria-label="edit-cart-item"
                                >
                                    <BlueEditIcon />
                                </IconButton>
                            )}
                            {isDeleteEnabled && (
                                <IconButton
                                    sx={{ padding: "0px 5px 5px" }}
                                    onClick={() => onDeleteClick(id)}
                                    aria-label="delete-cart-item"
                                >
                                    <DeleteIcons />
                                </IconButton>
                            )}
                        </Grid>
                    </Grid>
                    <Box sx={{ marginTop: "35px" }}>
                        {cartItemDetails.map((obj) => {

                            let labelValue = obj.value

                            if (
                                (`${obj?.label ?? ""}`.toLowerCase() === "transaction type") &&
                                ['fresh', 'additional'].includes(`${obj?.value ?? ""}`.toLowerCase())
                            ) {
                                labelValue = "LUMPSUM"
                            } else if (
                                ["redeem units", "switch units"].includes(`${obj?.label ?? ""}`.toLowerCase())
                            ) {
                                labelValue = obj.value ? Number(obj.value ?? 0).toFixed(3) : 0
                            }

                            return (
                                <Grid
                                    key={obj.label}
                                    container
                                    sx={{ marginBottom: "25px" }}
                                >
                                    <Grid item xs={5}>
                                        <Typography
                                            variant="body_500"
                                            sx={(theme: Theme) => ({
                                                lineHeight: "20px",
                                                letterSpacing: "0.02px",
                                                color: theme.palette.text.secondary
                                            })}
                                        >
                                            {obj.label}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={7}>
                                        <Typography
                                            variant="body_600"
                                            sx={(theme: Theme) => ({
                                                fontSize: "16px",
                                                color: theme.palette.text.primary,
                                                lineHeight: "20px",
                                                letterSpacing: "0.02px",
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                textAlign: 'right',
                                                textTransform: obj.isCapitalize ? "capitalize" : "none"
                                            })}
                                        >
                                            {/* {
                                                (isLabelTxnType && ['fresh', 'additional'].includes(`${obj?.value ?? ""}`.toLowerCase()))
                                                    ? 'LUMPSUM'
                                                    : obj.value
                                            } */}
                                            {labelValue}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )
                        })}
                    </Box>
                </Box >
            </Hidden>
            <Hidden lgDown>
                <Box>
                    <Grid
                        container
                        flexWrap="nowrap"
                        sx={{ columnGap: "15px" }}
                    >
                        <Grid
                            item
                            container
                            xs={10.5}
                            flexWrap="nowrap"
                            sx={{ columnGap: "15px" }}
                        >
                            <Grid
                                item
                                container
                                xs="auto"
                                justifyContent="center"
                                alignItems="center"
                            >
                                <Checkbox
                                    sx={(theme: Theme) => ({
                                        padding: "0px",
                                        '&.Mui-focusVisible, &:focus-within': {
                                            outline: `2px solid ${theme.palette.primary.main}`,
                                            outlineOffset: '2px',
                                            borderRadius: '4px',
                                        },
                                    })}
                                    checked={checked}
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                                        onCheckboxClick(fundType, id, event.target.checked)
                                    }
                                    inputProps={{
                                        'aria-label': `Select cart item ${fromSchemeName ?? ''}`.trim(),
                                    }}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={toSchemeName ? 5 : 11}
                            >
                                <SchemeInfo
                                    schemeImg={fromSchemeImg}
                                    schemeName={fromSchemeName}
                                    schemeCategory={fromSchemeCategory}
                                    schemeSubCategory={fromSchemeSubCategory}
                                    schemeRisk={fromSchemeRisk}
                                    schemeRiskColor={fromSchemeRiskColor}
                                    amcId={amcId}
                                />
                            </Grid>
                            {toSchemeName && (
                                <>
                                    <Grid
                                        item
                                        container
                                        xs={2}
                                        justifyContent="center"
                                        alignItems="center"
                                    >
                                        <FundTransferArrow />
                                    </Grid>
                                    <Grid item xs={5}>
                                        <SchemeInfo
                                            schemeImg={toSchemeImg}
                                            schemeName={toSchemeName}
                                            schemeCategory={toSchemeCategory}
                                            schemeSubCategory={toSchemeSubCategory}
                                            schemeRisk={toSchemeRisk}
                                            schemeRiskColor={toSchemeRiskColor}
                                            amcId={amcId}
                                        />
                                    </Grid>
                                </>
                            )}
                        </Grid>
                        <Grid
                            item
                            container
                            xs={1.5}
                            justifyContent="flex-end"
                            alignItems="flex-start"
                            sx={{ columnGap: "8px" }}
                        >
                            {isEditEnabled && (
                                <IconButton
                                    sx={{ padding: "0px 5px 5px" }}
                                    onClick={() => onEditClick(cartItemInfo)}
                                     aria-label="edit-cart-item"
                                >
                                    <BlueEditIcon />
                                </IconButton>
                            )}
                            {isDeleteEnabled && (
                                <IconButton
                                    sx={{ padding: "0px 5px 5px" }}
                                    onClick={() => onDeleteClick(id)}
                                    aria-label="delete-cart-item"
                                >
                                    <DeleteIcons />
                                </IconButton>
                            )}
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        sx={{
                            marginTop: "35px",
                            marginLeft: "37px",
                            rowGap: "30px",
                        }}
                    >
                        {cartItemDetails.map((obj) => {

                            const isLabelTxnType = `${obj?.label ?? ""}`.toLowerCase() === "transaction type"

                            return (
                                <Grid
                                    item
                                    container
                                    xs={3}
                                    key={obj.label}
                                    sx={{
                                        rowGap: "8px",
                                        paddingRight: "30px"
                                    }}
                                >
                                    <Grid item xs={12}>
                                        <Typography
                                            variant="body_500"
                                            sx={(theme: Theme) => ({
                                                lineHeight: "20px",
                                                letterSpacing: "0.02px",
                                                color: theme.palette.text.secondary
                                            })}
                                        >
                                            {obj.label}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography
                                            variant="body_600"
                                            sx={(theme: Theme) => ({
                                                fontSize: "16px",
                                                color: theme.palette.text.primary,
                                                lineHeight: "20px",
                                                letterSpacing: "0.02px",
                                                // whiteSpace: 'nowrap',
                                                // overflow: 'hidden',
                                                // textOverflow: 'ellipsis',
                                                textTransform: obj.isCapitalize ? "capitalize" : "none"
                                            })}
                                        >
                                            {
                                                (isLabelTxnType && ['fresh', 'additional'].includes(`${obj?.value ?? ""}`.toLowerCase()))
                                                    ? 'LUMPSUM'
                                                    : obj.value
                                            }
                                        </Typography>
                                    </Grid>
                                </Grid>
                            )
                        })}
                    </Grid>
                </Box>
            </Hidden>
        </>
    )
}